module.exports = __webpack_public_path__ + "static/media/auction-status.764dd88d.svg";